import React, { FunctionComponent } from 'react';

import '@fontsource/roboto';
import '@fontsource/roboto/300.css'; // Light (300)
import '@fontsource/roboto/400.css'; // Regular (400)
import '@fontsource/roboto/500.css'; // Medium (500)
import '@fontsource/roboto/600.css'; // Bold (700)
import '@fontsource/roboto/700.css'; // Bold (700)

import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

interface Props {
  label: any;
  color?: string;
  disabled?: boolean;
  multiLine?: boolean;
  width?: string;
  size?: any;
  value?: any;
  type?: string;
  error?: boolean;
  helperText?: string;
  onChange?: (e: any) => void;
}

const CssTextField = styled(TextField)({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: '#3478F6',
  },
  '& .MuiFormLabel-root.Mui-disabled': {
    color: 'grey',
  },
});

export const MyTextFiled: FunctionComponent<Props> = ({
  label,
  color,
  multiLine,
  disabled,
  width,
  size,
  value,
  type,
  error,
  helperText,
  onChange,
}) => (
  <CssTextField
    label={label}
    value={value}
    variant="standard"
    type={type}
    onChange={onChange}
    error={(error && value === '') || helperText !== ''}
    multiline={multiLine}
    disabled={disabled}
    style={{
      width,
      background: color,
      fontFamily: 'Roboto',
    }}
    helperText={error && value === '' ? 'Введите значение' : helperText}
    size={size}
  />
);

MyTextFiled.defaultProps = {
  value: '',
  color: undefined,
  disabled: false,
  multiLine: false,
  width: '100%',
  size: 'large',
  type: 'text',
  error: false,
  helperText: '',
  onChange: undefined,
};
